/**
 * For a given variant SKU, find the parent master variant SKU from a list of products
 */ function getSelectedVariantParentSku(itemList, sku) {
    var ref1;
    return (ref1 = itemList.filter((item)=>{
        var ref;
        return (ref = item.variants) === null || ref === void 0 ? void 0 : ref.filter((vItem)=>vItem.sku === sku
        ).length;
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.sku;
}

export { getSelectedVariantParentSku };
//# sourceMappingURL=get-selected-variant-parent-sku.js.map
